export enum PolicyDecisionTypes {
    APPROVED = "APPROVED",
    DENIED = "DENIED",
    NO_DECISION = "NO DECISION",
    OBLIGATION = "OBLIGATION",
    RETRY = "RETRY"
}